import React, { useState } from "react";
import { fallbackImages } from "../common/constants/fallback-images";

const ImageWithFallback = (prop) => {
  const {
    src,
    fallbackSrc = fallbackImages?.noImage,
    alt = "image",
    className = "",
    onClick = () => {},
    style = {},
  } = prop;
  const [isError, setIsError] = useState(false);

  const handleError = () => setIsError(true);

  return (
    <img
      src={isError ? fallbackSrc : src}
      onError={handleError}
      alt={alt}
      className={className}
      onClick={onClick}
      style={style}
    />
  );
};

export default ImageWithFallback;
